// Stable per-line-item key for cart rendering. A cart line is uniquely
// identified by product_id + variant_pack_size + sorted signature of
// any add-ons — so a Raw Vial WITH Recon Kit and the same Raw Vial
// WITHOUT are two different lines.
export function lineKey(item) {
  if (!item) return "";
  const base = item.variant_pack_size ? `${item.product_id}::${item.variant_pack_size}` : item.product_id;
  const addons = item.addons || [];
  if (addons.length === 0) return base;
  const sig = [...addons].map((a) => a.sku).sort().join(",");
  return `${base}::+${sig}`;
}
